import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import stubTrue from 'lodash/stubTrue'
import identity from 'lodash/identity'
import { FormattedMessage } from 'react-intl'
import Button from '@vtex/styleguide/lib/Button'

import { handleInputMask } from '@/checkout-instore-legacy/utils/inputUtils'
import { startClientProfileEvent } from '@/checkout-instore-legacy/utils/EventHelper'

export default class IdentificationInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      value: props.initialValue || '',
    }
  }

  componentDidMount() {
    if (this.props.getFocus) {
      this.focus()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    /* This function is a workaround for an android bug with input value changes.
    Cursor position stays at the same position when typing CPF with mask */
    const { mask } = this.props
    const { value } = this.state
    if (mask && this.input) {
      handleInputMask(prevState.value, value, mask, this.input)
    }
  }

  handleChange = (event) => {
    const value = event.target.value

    this.setState({
      value: this.props.normalize(value),
    })
  }

  focus = () => {
    if (this.input && this.input.focus) {
      this.input.focus()
    }
  }

  handleFocus = () => {
    startClientProfileEvent()
  }

  handleSubmit = (event) => {
    event.preventDefault()
    const { normalize, validate, onSubmit, onError, errorMessage } = this.props
    const { value } = this.state
    const normalizedValue = normalize(value)
    if (!normalizedValue) {
      // ignore empty values
      return
    }

    const isValid = validate(normalizedValue)
    if (isValid) {
      onSubmit(normalizedValue)
    } else {
      onError(errorMessage)
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.initialValue !== this.props.initialValue) {
      this.setState({
        value: nextProps.initialValue,
      })
    }

    if (nextProps.visible !== this.props.visible) {
      if (nextProps.visible) {
        setTimeout(() => {
          /* this timeout solves keyboard type change in Android devices due to toogling
      and focusing too fast (keyboard hides instead of changing type as expected) */
          if (this.input && this.input.focus) {
            this.input.focus()
          }
        }, 5)
      }
    }
  }

  render() {
    const {
      inputType,
      placeholder,
      invalidInputMessage,
      verifyInput,
      mask,
      normalize,
    } = this.props
    const { value } = this.state

    const isValid = verifyInput(value)
    let formattedValue = mask ? mask(value) : value
    formattedValue = formattedValue || ''
    const normalizedValue = normalize(value)

    return (
      <form
        className="form-horizontal"
        onSubmit={this.handleSubmit}
        ref={(el) => {
          this.form = el
        }}
        autoComplete="off"
      >
        <div className="mb4 mb5-ns tc">
          <input
            id="identification"
            className="w-100 w-80-ns w-30-l pa5 ba b--black-20 f4-ns lh-copy-ns lh-solid-l"
            type={inputType}
            placeholder={placeholder}
            value={formattedValue}
            onChange={this.handleChange}
            onFocus={this.handleFocus}
            autoComplete="off"
            autoCapitalize="off"
            spellCheck="false"
            autoCorrect="off"
            ref={(ref) => {
              this.input = ref
            }}
          />
        </div>
        {!isValid && invalidInputMessage && (
          <div className="light-red mt4 mb3 tc f4-ns">
            {invalidInputMessage}
          </div>
        )}
        <div className="w-100 w-30-l w-80-ns mt4 mt5-ns flex center">
          <Button
            id="customeridentifier-submit"
            kind="success"
            size="large"
            type="submit"
            disabled={!normalizedValue}
            block
          >
            <FormattedMessage id="identifyClient" />
          </Button>
        </div>
      </form>
    )
  }
}

IdentificationInput.propTypes = {
  inputType: PropTypes.string,
  invalidInputMessage: PropTypes.string,
  placeholder: PropTypes.string,
  verifyInput: PropTypes.func,
  validate: PropTypes.func,
  mask: PropTypes.func,
  normalize: PropTypes.func,
  onSubmit: PropTypes.func,
  onError: PropTypes.func,
  errorMessage: PropTypes.string,
  visible: PropTypes.bool,
  initialValue: PropTypes.string,
  getFocus: PropTypes.bool,
}

IdentificationInput.defaultProps = {
  inputType: 'text',
  invalidInputMessage: null,
  placeholder: null,
  verifyInput: stubTrue,
  validate: stubTrue,
  mask: null,
  normalize: identity,
  onSubmit: noop,
  onError: noop,
  errorMessage: '',
  visible: false,
  initialValue: null,
  getFocus: false,
}
